import { render, staticRenderFns } from "./UserLog.vue?vue&type=template&id=72fdcf9b&scoped=true&"
import script from "./UserLog.vue?vue&type=script&lang=js&"
export * from "./UserLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fdcf9b",
  null
  
)

export default component.exports